// Modelo Compañia para administrador.
export default class Procedure {
    id=""
    name=""
    description=""
    providerQuito=""
    providerGuayaquil=""
    selected=false
}



// WEBPACK FOOTER //
// ./src/model/Procedure.js